<template>
    <div class="project-tag-filter">
        <div
            v-if="activeBoard && activeBoard['id'] === Number($route.params.board_id) && ($route.name == 'Project' || $route.name == 'TaskModal')"
            ref="filtersContainer"
            class="sidemenu-item filters-container smart-list-users"
        >
            <a
                v-if="activeUserIndex == 'non-assigned'"
                href="#"
                @click.prevent="toggleMemberFilter('non-assigned')"
                class="tag-item hide-menu-link"
            >
                <span :class="['user-tag', 'not-assigned-task']">N/A</span>
                <Tooltip
                    size="large"
                    position="center"
                >
                    <div class="tooltip__label">Find forgotten tasks<br/><br/> This will filter on all tasks that do not have a user assigned</div>
                </Tooltip>
            </a>
            <a
                href="#"
                v-for="(item, index) in visibleUserTags"
                :key="index"
                @click.prevent="toggleMemberFilter(item.id)"
                class="tag-item hide-menu-link"
            >
                <div
                    :class="['user-tag', { 'active-member-filter': activeUserIndex === index }]"
                    :data-id="item.id"
                >
                    <img v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                    <span v-else>{{ firstLetterUsername(item.username) }}</span>
                </div>
                <Tooltip
                    size="large"
                    position="center"
                >
                    <div class="tooltip__flex">
                        <img class="tooltip__img" v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                        <span class="tooltip__img" v-else>{{ firstLetterUsername(item.username) }}</span>
                    </div>
                    <div class="tooltip__edit" v-if="item.id == currentUser.id">
                        <span>(You)</span>
                        <router-link to="/my-profile">
                            <img src="@/assets/images/edit-blue.svg" alt="">
                        </router-link>
                    </div>
                    <div class="tooltip__label">Name:</div>
                    <div class="tooltip__paragraph">{{ item.name || '' }}</div>
                    <div class="tooltip__label">Username:</div>
                    <div class="tooltip__paragraph">{{ item.username }}</div>
                    <div class="tooltip__label">Bio:</div>
                    <div class="tooltip__paragraph" v-html="formatBio(item.bio)"></div>
                </Tooltip>
            </a>
            <div class="toggle-dropdown">
                <a
                    @click="toggleUserTagsDropdown"
                    class="tag-item hide-menu-link user-filter user-filter-btn"
                    v-if="dropdownUserTags.length > 0 && ($route.name == 'Project' || $route.name == 'SmartList' || $route.name == 'Activities')"
                >

                    <div v-if="isSmallScreen" class="mob-view">
                        <i class="icon-activities"></i>
                        <span>User</span>
                    </div>

                    <span v-else >Filter by user</span>
                </a>
                <Dropdown v-if="isAvatarDropdownVisible" position="center" size="small">
                    <input
                        ref="avatarInput"
                        type="text"
                        class="text-input"
                        placeholder="Search..."
                        v-model="searchQuery"
                    />
                    <a
                        href="#"
                        @click.prevent="toggleMemberFilter('non-assigned')"
                        class="tag-item hide-menu-link"
                    >
                        <div class="member-wrap dropdown-item">
                            <div class="avatar-wrap">
                                <span>N/A</span>
                            </div>
                            <span>Non assigned</span>
                        </div>
                    </a>
                    <a
                        href="#"
                        v-for="(item, index) in filteredDropdownUserTags"
                        :key="index"
                        @click.prevent="toggleMemberFilter(item.id)"
                        class="tag-item hide-menu-link"
                    >
                        <div :data-id="item.id" class="member-wrap dropdown-item">
                            <div class="avatar-wrap">
                                <img v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                                <span v-else>{{ firstLetterUsername(item.username) }}</span>
                            </div>
                            <span>{{ item.username || '' }}</span>
                        </div>
                    </a>
                </Dropdown>
            </div>
            <div v-if="dropdownTags && dropdownTags.length && !isSmallScreen> 0" class="divider"></div>
        </div>
        <div
            v-if="activeBoard && activeBoard['id'] === Number($route.params.board_id) && ($route.name == 'Project' || $route.name == 'TaskModal' || $route.name == 'Activities')"
            ref="filtersTagsContainer"
            class="sidemenu-item filters-container smart-list-users"
        >
            <a
                href="#"
                v-for="(item, index) in visibleTags"
                :key="index"
                @click.prevent="toggleTagFilter(item.id)"
                class="tag-item hide-menu-link"
            >
                <div
                    :class="['user-tag', { 'active-member-filter': activeTagIndex === index }]"
                    :data-id="item.id"
                >
                    <i :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                </div>
            </a>
            <div class="toggle-dropdown">
                <a
                    @click="toggleTagsDropdown"
                    class="tag-item hide-menu-link user-filter tag-filter-btn"
                    v-if="dropdownTags && dropdownTags.length > 0 && ($route.name == 'Project' || $route.name == 'SmartList' || $route.name == 'Activities')"
                > 
                    <div v-if="isSmallScreen" class="mob-view">
                        <i class="icon-activities"></i>
                        <span>Tag</span>
                    </div>

                    <span v-else >Filter by tag</span>
                </a>
                <Dropdown v-if="isDropdownVisible" position="left" size="small">
                    <input
                        ref="tagsInput"
                        type="text"
                        class="text-input"
                        placeholder="Search..."
                        v-model="t_searchQuery"
                    />
                    <a
                        href="#"
                        v-for="(item, index) in filteredDropdownTags"
                        :key="index"
                        @click.prevent="toggleTagFilter(item.id)"
                        class="tag-item hide-menu-link"
                    >
                        <div :data-id="item.id" class="member-wrap dropdown-item">
                            <i class="tag-icon" :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                            <span>{{ item.name || '' }}</span>
                        </div>
                    </a>
                </Dropdown>
            </div>
        </div>
        <div v-if="$route.name == 'SmartList' || $route.name == 'Activities'" ref="filtersSmartContainer" class="sidemenu-item filters-container">
            <a
                v-if="activeUserIndex == 'non-assigned'"
                href="#"
                @click.prevent="toggleUserFilter('non-assigned')"
                class="tag-item hide-menu-link"
            >
                <span :class="['user-tag', 'not-assigned-task']">N/A</span>
                <Tooltip
                    size="large"
                    position="center"
                >
                    <div class="tooltip__label">Find forgotten tasks<br/><br/> This will filter on all tasks that do not have a user assigned</div>
                </Tooltip>
            </a>
            <a
                href="#"
                v-for="(item, index) in visibleUsers"
                :key="index"
                @click.prevent="toggleUserFilter(item.id)"
                class="tag-item hide-menu-link"
            >
                <div
                    :class="['user-tag', { 'active-member-filter': activeUserIndex === index }]"
                    :data-id="item.id"
                >
                    <img v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                    <span v-else>{{ firstLetterUsername(item.username) }}</span>
                </div>
                <Tooltip
                    size="large"
                    position="center"
                >
                    <div class="tooltip__flex">
                        <img class="tooltip__img" v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                        <span class="tooltip__img" v-else>{{ firstLetterUsername(item.username) }}</span>
                    </div>
                    <div class="tooltip__edit" v-if="item.id == currentUser.id">
                        <span>(You)</span>
                        <router-link to="/my-profile">
                            <img src="@/assets/images/edit-blue.svg" alt="">
                        </router-link>
                    </div>
                    <div class="tooltip__label">Name:</div>
                    <div class="tooltip__paragraph">{{ item.name || '' }}</div>
                    <div class="tooltip__label">Username:</div>
                    <div class="tooltip__paragraph">{{ item.username }}</div>
                    <div class="tooltip__label">Bio:</div>
                    <div class="tooltip__paragraph" v-html="formatBio(item.bio)"></div>
                </Tooltip>
            </a>
            <div class="toggle-dropdown relative">
                <a
                    @click="toggleUsersDropdown"
                    class="tag-item hide-menu-link user-filter user-filter-btn"
                    v-if="dropdownUsers.length"
                >
                 <div v-if="isSmallScreen" class="mob-view">
                        <i class="icon-activities"></i>
                        <span>User</span>
                    </div>

                    <span v-else >Filter by user</span>
                </a>
                <Dropdown 
                    v-if="isSmartAvatarDropdownVisible"
                    ref=""
                    position="center"
                    size="small"
                    class="member-dropdown">
                    
                    <input
                        ref="smartAvatarInput"
                        type="text"
                        class="text-input"
                        placeholder="Search..."
                        v-model="u_searchQuery"
                    />
                    <a
                        v-if="$route.name == 'SmartList'"
                        href="#"
                        @click.prevent="toggleUserFilter('non-assigned')"
                        class="tag-item hide-menu-link"
                    >
                        <div class="member-wrap dropdown-item">
                            <div class="avatar-wrap">
                                <span>N/A</span>
                            </div>
                            <span>Non assigned</span>
                        </div>
                    </a>
                    <a
                        href="#"
                        v-for="(item, index) in filteredDropdownUsers"
                        :key="index"
                        @click.prevent="toggleUserFilter(item.id)"
                        class="tag-item hide-menu-link"
                    >
                        <div :data-id="item.id" class="member-wrap dropdown-item">
                            <div class="avatar-wrap">
                                <img v-if="item.portrait" :src="baseURL + item.portrait" alt="">
                                <span v-else>{{ firstLetterUsername(item.username) }}</span>
                            </div>
                            <span>{{ item.username || '' }}</span>
                        </div>
                    </a>
                </Dropdown>
            </div>
            <div v-if="activeBoard && activeBoard['id'] === Number($route.params.board_id) && ($route.name == 'Project' || $route.name == 'TaskModal' || $route.name == 'SmartList' || $route.name == 'Activities') && !isSmallScreen" class="divider"></div>
        </div>
        <div
            v-if="activeBoard && activeBoard['id'] === Number($route.params.board_id) && $route.name == 'SmartList'"
            ref="filtersTagsContainer"
            class="sidemenu-item filters-container smart-list-users"
        >
            <a
                href="#"
                v-for="(item, index) in visibleTags"
                :key="index"
                @click.prevent="toggleSmartTagFilter(item.id)"
                class="tag-item hide-menu-link"
            >
                <div
                    :class="['user-tag', { 'active-member-filter': activeSmartTagIndex.includes(index) }]"
                    :data-id="item.id"
                >
                    <i :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                </div>
            </a>
            <div class="toggle-dropdown">
                <a
                    @click="toggleTagsDropdown"
                    class="tag-item hide-menu-link user-filter tag-filter-btn"
                    v-if="dropdownTags && dropdownTags.length > 0 && ($route.name == 'Project' || $route.name == 'SmartList' || $route.name == 'Activities')"
                >
                <div v-if="isSmallScreen" class="mob-view">
                    <i class="icon-activities"></i>
                    <span>Tag</span>
                </div>

                <span v-else >Filter by tag</span>
            
                </a>
                <Dropdown v-if="isDropdownVisible" position="left" size="small">
                    <input
                        ref="tagsInput"
                        type="text"
                        class="text-input"
                        placeholder="Search..."
                        v-model="t_searchQuery"
                    />
                    <a
                        href="#"
                        v-for="(item, index) in filteredDropdownTags"
                        :key="index"
                        @click.prevent="toggleSmartTagFilter(item.id)"
                        class="tag-item hide-menu-link"
                    >
                        <div :data-id="item.id" class="member-wrap dropdown-item">
                            <i class="tag-icon" :style="{ 'color': `${item.color}` }" :class="`icon-${item.symbol}`"></i>
                            <span>{{ item.name || '' }}</span>
                        </div>
                    </a>
                </Dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import {api} from "@/mixins/axios";
import {baseURL} from "@/mixins/helpers";
import Tooltip from "@/components/atoms/Tooltip.vue";
import Dropdown from "@/components/atoms/Dropdown.vue";

export default {
	components: {
        Tooltip,
        Dropdown,
	},
    props: [
        'dropdownUserTags',
        'dropdownUsers',
        'visibleUserTags',
        'visibleUsers',
        'isAvatarDropdownVisible',
        'isSmartAvatarDropdownVisible',
        'visibleTags',
        'dropdownTags',
        'isDropdownVisible'
    ],
    data() {
        return {
            activeUserIndex: null,
            activeTagIndex: null,
            activeSmartTagIndex: [],
            searchQuery: '',
            baseURL: baseURL(),
            u_searchQuery: '',
            t_searchQuery: '',
            isSmallScreen: false
        };
    },
    watch: {
        $route() {
            this.activeUserIndex = ''
            this.searchQuery = ''
            this.t_searchQuery = ''
            this.u_searchQuery = ''
        }
    },
    computed: {
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        filteredDropdownUserTags() {
        // Filter dropdownTags based on the searchQuery
            return this.dropdownUserTags.filter((item) => {
                return item.username.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        },
        filteredDropdownUsers() {
        // Filter dropdownTags based on the searchQuery
            return this.dropdownUsers.filter((item) => {
                return item.username.toLowerCase().includes(this.u_searchQuery.toLowerCase());
            });
        },
        filteredDropdownTags() {
        // Filter dropdownTags based on the searchQuery
            return this.dropdownTags.filter((item) => {
                return item.name.toLowerCase().includes(this.t_searchQuery.toLowerCase());
            });
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
    },
    methods: {
        toggleMemberFilter(item) {
            if(this.activeUserIndex === item) {
                this.$store.dispatch('setUserFilter', 'no-filter')
                this.activeUserIndex = null
                this.$emit('setFilterUserTags', null)
            } else {
                this.$store.dispatch('setUserFilter', `${item}`)
                this.activeUserIndex = item
                this.$emit('setFilterUserTags', item)
            }
            this.searchQuery = '';

            this.closeAvatarDropdown()
        },
        toggleSmartTagFilter(item) {
            if(this.activeSmartTagIndex.includes(item)) {
                this.activeSmartTagIndex.splice(this.activeSmartTagIndex.indexOf(item), 1)
            } else {
                this.activeSmartTagIndex.push(item)
            }
            if(this.activeSmartTagIndex.length == 0) {
                this.$store.dispatch('setSmartListTagFilter', ['no-filter'])
                this.$emit('setFilterSmartTags', null)
            } else {
                this.$store.dispatch('setSmartListTagFilter', this.activeSmartTagIndex)
                this.$emit('setFilterSmartTags', this.activeSmartTagIndex)
            }
            this.searchQuery = '';

            this.closeInputDropdown()
        },
        toggleTagFilter(item) {
            if(this.activeTagIndex === item) {
                this.$store.dispatch('setTagFilter', 'no-filter')
                this.activeTagIndex = null
                this.$emit('setFilterTags', null)
            } else {
                this.$store.dispatch('setTagFilter', `${item}`)
                this.activeTagIndex = item
                this.$emit('setFilterTags', item)
            }
            this.searchQuery = '';

            this.closeInputDropdown()
        },
        toggleUserFilter(item) {
            if(this.activeUserIndex === item) {
                this.$store.dispatch('setSmartListFilter', 'no-filter')
                this.activeUserIndex = null
                this.$emit('setFilterSmartUsers', null)
            } else {
                this.$store.dispatch('setSmartListFilter', `${item}`)
                this.activeUserIndex = item
                this.$emit('setFilterSmartUsers', item)
            }
            this.searchQuery = '';

            this.closeAvatarDropdown()
        },
        formatBio(bio) {
            return bio ? bio.replace('\n', '<br />') : ''
        },
        firstLetterUsername(username) {
            if (typeof username !== 'string' || username.length === 0) {
                return "";
            }
            return username.charAt(0).toUpperCase();
        },
        toggleUserTagsDropdown() {
            this.$emit('setAvatarDropdownVisible', !this.isAvatarDropdownVisible)
            setTimeout(() => {
                this.$refs.avatarInput?.focus();
            }, 100);
            
        },
        toggleTagsDropdown() {
            this.$emit('setDropdownVisible', !this.isDropdownVisible)
            setTimeout(() => {
                this.$refs.tagsInput?.focus();
            }, 100);
            
        },
        toggleUsersDropdown() {
            this.$emit('setSmartAvatarDropdownVisible', !this.isSmartAvatarDropdownVisible)
            setTimeout(() => {
                this.$refs.smartAvatarInput?.focus();
            }, 100);
        },
        closeAvatarDropdown() {
            setTimeout(() => {
                this.$emit('setAvatarDropdownVisible', false)
                this.$emit('setSmartAvatarDropdownVisible', false)
            }, 100)
        },
        closeInputDropdown() {
            setTimeout(() => {
                this.$emit('setDropdownVisible', false)
            }, 100)
        },
        closeDropdownOnOutsideClick(event) {
            // Check if the click event occurred outside the dropdown element
            if(!this.$el.contains(event.target)) {
                this.closeAvatarDropdown()
                this.closeInputDropdown()
            }
            if(this.$el.contains(event.target) && event.target.classList.contains('tag-filter-btn') && (this.isAvatarDropdownVisible || this.isSmartAvatarDropdownVisible)) {
                this.closeAvatarDropdown()
            } else if(this.$el.contains(event.target) && event.target.classList.contains('user-filter-btn') && (this.isDropdownVisible)) {
                this.closeInputDropdown()
            }
        },
        checkScreenWidth() {
            this.isSmallScreen = window.innerWidth <= 768;
        }
    },
    mounted() {
        document.addEventListener('click', this.closeDropdownOnOutsideClick);
        this.checkScreenWidth();
        window.addEventListener('resize', this.checkScreenWidth);
    },
    beforeDestroy() { 
        document.removeEventListener('click', this.closeDropdownOnOutsideClick);
        window.removeEventListener('resize', this.checkScreenWidth);
    },
};
</script>

<style lang="scss">
.project-tag-filter {
    display: flex;
    gap: 7px;
}

.divider {
    width: 4px;
    height: 4px;
    background-color: #fff;
    border-radius: 50%;
    margin: 0 5px;
}

.mob-view {
    margin-left: 18px;

    i {
        margin-right: 5px;
    }
}
</style>
